module.exports = __webpack_public_path__ + "img/my_account.82ad9fb9.svg";